import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/wsp.png")